import React from 'react';
import './Wordmark.scss';

export const OUTFINO_AVATAR_URL =
  'https://api.outfino.io/v3/storage/assets/outfino_avatar.jpg';

// Outfino Insights lockup: the app-icon avatar (rounded like an iOS icon)
// + the "Outfino Insights" wordmark. `size` scales the icon.
export default function Wordmark({ size = 34, className = '', hideName = false }) {
  return (
    <span className={`o-wordmark ${className}`.trim()}>
      <img
        className="o-wordmark__icon"
        src={OUTFINO_AVATAR_URL}
        alt="Outfino"
        width={size}
        height={size}
        style={{ width: size, height: size }}
        loading="eager"
      />
      <span className="o-wordmark__text">
        {!hideName && <span className="o-wordmark__name">Outfino</span>}
        <span className="o-wordmark__sub">Partners</span>
      </span>
    </span>
  );
}
